import React from 'react';
import ReactPaginate from "react-paginate";
import "./style.scss";
import cx from "classnames";

const Index = ({pageCount=1,currentPage, className="",handlePageClick}) => {
    const classesPrevBtn = cx(
        'd-pagination__prev',
    );
    const classesNextBtn = cx(
        'd-pagination__next',
    );

    return (
        <div className={`d-pagination ${className}`}>
            <div className="d-pagination__wrap">
                <ReactPaginate
                    initialPage={currentPage - 1}
                    forcePage={currentPage-1}
                    previousLabel={<div className={classesPrevBtn}/>}
                    nextLabel={<div className={classesNextBtn}/>}
                    containerClassName={"d-pagination__items"}
                    pageClassName={"d-pagination__item"}
                    pageCount={pageCount}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={3}
                    onPageChange={data => handlePageClick(data.selected)}
                    disableInitialCallback={true}
                />
            </div>
        </div>
    );
};

export default Index;